import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { Box, Button, Variants as ButtonVariants } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'

interface AddExpenseButtonProps {
  type: ButtonVariants
  canUsePerDiems: boolean
}

export const AddButton = ({ type, canUsePerDiems }: AddExpenseButtonProps) => {
  const { navigation } = useExpensesNavigation()
  const { expensableGroupsEnabled } = useOutletContext<RouteContextParams>()
  const { groupId } = useParams()
  const navigate = useNavigate()

  return (
    <Box alignSelf="flexEnd">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type={type} iconName="add">
            {i18n.t('expenses_v2.group_detail.add_expense')}
          </Button.Decorative>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="start">
          <PopoverMenu.TouchableOption
            title={i18n.t('command_bar.plugins.actions.my_expenses.add_new_expense')}
            onClick={() => navigate(navigation.helpers.newExpenseOcr())}
          />
          <PopoverMenu.TouchableOption
            title={i18n.t('command_bar.plugins.actions.my_expenses.add_new_mileage')}
            onClick={() => navigate(navigation.helpers.newMileage())}
          />
          {canUsePerDiems && (
            <PopoverMenu.TouchableOption
              title={i18n.t('command_bar.plugins.actions.my_expenses.add_new_per_diem')}
              onClick={() => navigate(navigation.helpers.newPerDiem())}
            />
          )}
          {expensableGroupsEnabled && !groupId && (
            <PopoverMenu.TouchableOption
              title={i18n.t('command_bar.plugins.actions.my_expenses.add_new_group')}
              onClick={() => navigate(navigation.helpers.newGroup())}
            />
          )}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
